<p-dialog [(visible)]="welcomeDialog" styleClass="p-fluid w-11/12 md:w-1/2 lg:w-1/3 h-[14rem]" [modal]="true"
  (onHide)="cancel()">
  <ng-template pTemplate="content">
    @if (loadingSpinner) {
      <div class="progress-spinner">
        <p-progressSpinner class="spinner"></p-progressSpinner>
      </div>
    }
    <app-status [welcomeMessage]="true" (statusChange)="statusChange($event)"
    (loadedStatus)="loadedStatus($event)"></app-status>
  </ng-template>
  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>